import { render } from "./DropDownLanguage.vue?vue&type=template&id=1a209cdc"
import script from "./DropDownLanguage.vue?vue&type=script&lang=js"
export * from "./DropDownLanguage.vue?vue&type=script&lang=js"

import "./DropDownLanguage.vue?vue&type=style&index=0&id=1a209cdc&lang=css"
script.render = render

export default script